import React from 'react';
import LandingVideo from 'assets/videos/Banner.mp4';
import Helmet from 'components/Helmet';

import './index.css';

function Landing() {
    return (
        <div className='landing'>
            <Helmet
                title='Study with The SAT Crash Course - The SAT Crash Course'
                description='Take a free SAT practice exam and get a detailed report card. You can also purchase services including The SAT Crash Course and new Digital SAT practice exams.'
            />
            <div className='landing__videoWrapper'>
                <video
                    className='landing__video'
                    autoPlay
                    muted
                    loop
                    playsInline
                >
                    <source src={LandingVideo} type='video/mp4' />
                </video>
            </div>
        </div>
    );
}

export default Landing;